import React, { ReactElement } from "react";
import styled from "styled-components/macro";
import { QRCode } from "react-qrcode-logo";
import ChangingBackgrounds from "./ChangingBackgrounds";

const QrCodeDiv = styled.div`
	position: absolute;
	top: 0%;
	bottom: 0%;
	left: 0%;
	right: 0%;
	background-color: #ffffffc4;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	font-size: 45px;
	gap: 50px;
	text-align: center;
	padding: 30px;
`;
const Frame = styled.div`
	position: absolute;
	background-color: #ffffffc4;
	padding: 23px;
	display: flex;
	flex-direction: column;
	padding: 22px 22px;
`;
const TitleFrame = styled(Frame)`
	bottom: 13%;
	right: 0%;
`;
const Title = styled.div`
	font-size: 32px;
	font-weight: 675;
	display: flex;
	gap: 10px;
`;
const BlueDiv = styled.span`
	color: #004990;
`;
const BlueDivLogo = styled(BlueDiv)`
	font-size: 24px;
`;
const QRFrame = styled(Frame)`
	top: 13%;
	left: 0%;
	width: 880px;
`;
const QRContainer = styled.div`
	display: flex;
	flex-direction: row-reverse;
	gap: 15px;
`;
const QRSubtitle = styled.div`
	font-size: 17px;
	font-weight: 600;
	text-align: left;
	line-height: initial;
`;

const LogoContainer = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	justify-content: space-around;
`;
const LogoTitle = styled.div`
	font-size: 20px;
	font-weight: 800;
	text-align: left;
	line-height: 1.13;
	letter-spacing: 0.85px;
`;
const LogoText = styled.div`
	display: flex;
	flex-direction: column;
`;
const Logo = styled.div`
	height: 135px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
	background-image: url("logo_IK.png");
`;

function QrCodeDesktop(): ReactElement | null {
	//const qrCode = useSelector<RootState, string | undefined>((store) => store.selections.qrCode);

	// Build our qr code to point to ourselves
	const { protocol, hostname, port, search } = window.location;
	let url = protocol + "//" + hostname;
	if (port && port !== "80") url += ":" + port;
	// url = "https://infinitekitchen.3dmanager.app";
	// url = "https://infinitekitchen.3dmanager.app/";
	url = url + "?desktop";
	if (search) url += "-" + search.replaceAll("?", "");

	// qrCode || (process.env.PUBLIC_URL || "https://infinitekitchen.3dmanager.app") + "/";
	//if (!qrCode) return null;
	console.log("qrcode url", url);

	return (
		<QrCodeDiv>
			<ChangingBackgrounds />
			<TitleFrame>
				<Title>
					Next-Gen Home <BlueDiv>Improvement</BlueDiv> Experience with Lowe&#39;s
				</Title>
			</TitleFrame>
			<QRFrame>
				<QRContainer>
					{/*<QRCodeImage />*/}
					<QRCode
						value={url}
						size={280}
						logoImage="QRCodeCenter.jpg"
						logoWidth={100}
						quietZone={20}
						ecLevel="H"
						removeQrCodeBehindLogo
					/>
					<LogoContainer>
						<Logo />
						<LogoText>
							<LogoTitle>
								<BlueDivLogo>Lowe&#39;s Innovation Labs</BlueDivLogo> is using Google&#39;s new
								Immersive Stream to help customers visualize their dream kitchen in high-end 3D on
								nearly any smartphone.
								<br />
								<br />
								To try the demo, use your camera app to scan the QR code.
							</LogoTitle>
						</LogoText>
					</LogoContainer>
				</QRContainer>
				<QRSubtitle></QRSubtitle>
			</QRFrame>
		</QrCodeDiv>
	);
}

export default QrCodeDesktop;
